module.exports = __webpack_public_path__ + "static/media/Veg.ec63c8da.svg";